export default "__VITE_ASSET__H$OQ8uzY__"